import { render } from "./UserMenu.vue?vue&type=template&id=d0423294&scoped=true&ts=true"
import script from "./UserMenu.vue?vue&type=script&lang=ts"
export * from "./UserMenu.vue?vue&type=script&lang=ts"

import "./UserMenu.vue?vue&type=style&index=0&id=d0423294&scoped=true&lang=css"

import exportComponent from "/home/forge/crm.thebcr.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0423294"]])

export default __exports__